import i18next from 'i18next';

i18next.addResources('en', 'BarleyInformationModal', {
  variety: 'Barley Variety',
  farmName: 'Farm Name',
  fieldName: 'Field Name'
});
